<template>
  <div id="honor">
    <div class="mainWidth">
      <div class="main_box">
        <mu-row gutter class="honor_box" v-for="item in $t('about.honor.tags')" :key="item.foundImg">
          <mu-col width="100" tablet="30" desktop="30" class="honor_img_box">
            <img :src="item.foundImg" alt="">
          </mu-col>
          <mu-col width="100" tablet="70" desktop="70" class="honor_title_box">
            <div class="title">{{item.title}}</div>
            <div class="subtitle">{{item.subtitle}}</div>
          </mu-col>
        </mu-row>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #honor{
    overflow:hidden;
    background-color:#E6E6E6;
    padding-bottom:60px;
    .main_box{
      background:#fff;
      overflow:hidden;
      margin-top:17px;
      padding:88px;
      .honor_box{
        margin:20px 0px;
        overflow:hidden;
        .honor_img_box{
          height:160px;
          text-align:center;
          img{
           height:inherit!important;
          }
        }
        .honor_title_box{
          .title{
            font-family: HelveticaNeue-UltraLight;
            font-size: 46px;
            color: #3B3B3B;
            letter-spacing: 0;
            height:101px;
            line-height:140px;
          }
          .subtitle{
            background: #F7F9FB;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #3B3B3B;
            letter-spacing: 0;
            line-height:59px;
            height:59px;
          }
        }
      }

    }
  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/honor.vue